import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import { TimesheetReportDto, RequestTimesheetRecordEmailDto, ResponseReportSendEmailDto } from "../dto/timesheet-report.dto";

@Injectable()
export class TimesheetReportApi {
    private service: string = '';
    private model: string = 'gdTimesheet';

    constructor(
        private nestApiProvider: NestApiProvider) {
    }

    preview() {
    }

    downloadExcel(data: TimesheetReportDto) {
        const method: string = 'POST';
        const func: string = 'downloadExcel';
        const params: TimesheetReportDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
    }

    downloadPdf(data: TimesheetReportDto) {
        const method: string = 'POST';
        const func: string = 'downloadPdf';
        const params: TimesheetReportDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
    }

    reportSendEmailExcel(data: RequestTimesheetRecordEmailDto): Observable<ResponseReportSendEmailDto> {
        const method: string = 'POST';
        const func: string = 'reportSendEmailExcel';
        const params: RequestTimesheetRecordEmailDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseReportSendEmailDto>(method, url, params, urlParams, body);
    }

    public reportSendEmailPdf(data: RequestTimesheetRecordEmailDto): Observable<ResponseReportSendEmailDto> {
        const method: string = 'POST';
        const func: string = 'reportSendEmailPdf';
        const params: RequestTimesheetRecordEmailDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseReportSendEmailDto>(method, url, params, urlParams, body);
    }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/timesheet-report.api.ts